import { ChartConfig, ChartIndicator } from "@v2/components/ui/chart";

export const InOfficeChartLegend = ({
    chartConfig
  }: {
    chartConfig: ChartConfig;
  }) => (
    <div className="flex flex-col gap-2 font-normal">
      <div className="flex items-center gap-2">
        <ChartIndicator
          indicator={chartConfig.favorite.indicator || 'dot'}
          nestLabel={false}
          indicatorColor={chartConfig.favorite.color || '#000'}
        />
        <span className="text-gray-600 text-sm">Favorite</span>
      </div>
      <div className="flex items-center gap-2">
        <ChartIndicator
          indicator={chartConfig.inOffice.indicator || 'dot'}
          nestLabel={false}
          indicatorColor={chartConfig.inOffice.color || '#000'}
        />
        <span className="text-gray-600 text-sm">In Office</span>
      </div>
    </div>
  );